export default {
  list: [],
  permissions: [],
  current: {
    name: '',
    assignor: {
      assignor_type: '',
      vortx_assignor_integration_documents_status: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/profile/store/state.js